'use strict';

var React = require('react');

var SvgProductReturnsMinor = function SvgProductReturnsMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 12a6 6 0 0 0 6 6h9a1 1 0 0 0 0-2h-9a4 4 0 1 1 0-8h6.526l-2.233 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 1 0-1.414 1.414l2.233 2.293h-6.526a6 6 0 0 0-6 6Z"
  }));
};

exports.SvgProductReturnsMinor = SvgProductReturnsMinor;
